// extracted by mini-css-extract-plugin
export var infoRow = "_v2-2";
export var labelContainer = "_v2-0";
export var rightInfo = "_v2-1";